import { ConfigProvider, Table } from "antd";

export const TableWithRow = (props) => {
  return (
	  <ConfigProvider
		  theme={{
			  components: {
				  Table: {
					  rowSelectedBg: '#007aff26'
				  }
			  }
		  }}
	  >
	  	<Table {...props} />
	  </ConfigProvider>
  )
}